import React, { Fragment, useContext, useState } from 'react';
import { centsToDollars } from '../../../utils';
import { Transition } from '@headlessui/react';
import { AffiliateProduct } from '../../../../interfaces/affiliate_products';
import { AffiliateProductDetailModal } from './AffiliateProductDetailModal';
import { getAnalytics, logEvent } from 'firebase/analytics';
import TrackingContext from '../../../Providers/TrackingContext';

type Props = {
  product: AffiliateProduct;
  display_partner_id: number;
  card_width?: string;
};

const AffiliateProductCard: React.FC<Props> = ({
  product,
  display_partner_id,
  card_width,
}) => {
  const [show, setShow] = useState(false);
  const { trackFBEvent, trackGAEvent } = useContext(TrackingContext);

  return (
    <>
      <Transition
        show={true}
        as={Fragment}
        enter="transform transition ease-in-out duration-500 sm:duration-700"
        enterFrom="translate-y-full"
        enterTo="translate-y-0"
        leave="transform transition ease-in-out duration-500 sm:duration-700"
        leaveFrom="translate-y-0"
        leaveTo="translate-y-full"
      >
        <div className="bg-surface">
          <div
            key={product?.unique_id}
            onClick={() => {
              logEvent(getAnalytics(), 'affiliate_product_clicked', {
                affiliate_product_id: product.id,
                affiliate_product_name: product.name,
                affiliate_partner: product.affiliate,
                display_merchant: display_partner_id,
                is_affiliate: true,
              });
              trackGAEvent(
                'select_item',
                {
                  items: [
                    {
                      item_id: `aflt_${product.id}`,
                      item_name: product.name,
                      affiliation: 'SNAPnTAP',
                      item_category:
                        product.tags?.length !== 0
                          ? product.tags[0]
                          : 'affiliate',
                      item_list_id: 'affiliate_product',
                      item_list_name: 'Affiliate Product',
                      price: (product.base_price ?? 0) / 100.0,
                    },
                  ],
                },
                [display_partner_id],
              );
              trackFBEvent(
                'AffiliateProductClick',
                {
                  content_ids: [`aflt_${product.id}`],
                  content_type: 'affiliate_product',
                  content_name: [product.name],
                },
                true,
                [display_partner_id],
              );
              setShow(true);
            }}
            className=" cursor-pointer text-on-surface hover:text-primary"
          >
            <div
              className={`relative bg-primary/10 rounded-lg shadow-md pb-2 ${
                card_width && 'w-40 md:w-32 lg:w-40 2xl:w-44'
              }`}
            >
              {product?.base_price && (
                <div className="absolute top-2 px-2 right-2 z-10 rounded-md bg-surface">
                  <p className="font-semibold text-md text-on-surface">
                    {centsToDollars(product?.base_price)}
                  </p>
                </div>
              )}
              <div className="group block w-full  aspect-w-14 aspect-h-14 rounded-t-lg bg-gray-100 overflow-hidden">
                <img
                  src={product?.image_url}
                  alt=""
                  className="object-cover pointer-events-none group-hover:opacity-75"
                />
              </div>
              <div className="flex flex-row justify-between items-start">
                <div className="mx-2 mb-0 py-2 text-md font-semibold text-on-surface  pointer-events-none">
                  <p className="line-clamp-2">{product?.name}</p>
                </div>
              </div>
              <p className="line-clamp-3 mx-2 text-on-surface  pointer-events-none  ">
                {product.description ?? ''}
              </p>
            </div>
          </div>
        </div>
      </Transition>
      {show && (
        <AffiliateProductDetailModal
          onDone={() => {
            setShow(false);
          }}
          product={product}
          display_partner_id={display_partner_id}
        />
      )}
    </>
  );
};

export default AffiliateProductCard;
